export default __webpack_public_path__ + "static/media/thaqwa-spoon-logo-nobg.1ec2cc6c.svg";